<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="dialogResaginar.estatus"
    persistent
    max-width="1200"
  >
    <v-card>
    	<v-card-title class="text-subtitle-1">
    	  Reasignar prospectos de manera masiva v1
    	  <v-spacer></v-spacer>
    	  <v-icon @click="dialogResaginar.estatus = false">mdi-close</v-icon>
    	</v-card-title>
    	<v-card-text>
    		<v-row>
    			<v-col cols="12" md="6">
		    		<v-autocomplete
		          filled
		          dense
		          clearable
		          v-model="vendedora"
		          :items="vendedoras"
		          label="Vendedora origen (opcional; o usa Plantel)"
		          hide-details
		          item-text="nombre_completo"
		          item-value="id_usuario"
		          return-object
		        >
		        </v-autocomplete>
    			</v-col>

    			<v-col cols="12" md="6">
		    		<v-autocomplete
		          filled
		          dense
		          clearable
		          v-model="plantelFiltro"
		          :items="plantelesDisponibles"
		          label="Plantel"
		          hide-details
		          item-text="plantel"
		          item-value="idplantel"
		        >
		        </v-autocomplete>
    			</v-col>

    			<v-col cols="12" md="3">
    				<v-text-field
    				  filled
    				  dense
    				  clearable
    				  hide-details
    				  type="date"
    				  v-model="fechaInicio"
    				  label="Fecha inicio"
    				></v-text-field>
    			</v-col>

    			<v-col cols="12" md="3">
    				<v-text-field
    				  filled
    				  dense
    				  clearable
    				  hide-details
    				  type="date"
    				  v-model="fechaFin"
    				  label="Fecha fin"
    				></v-text-field>
    			</v-col>

    			<v-col cols="12" md="6">
    				<v-radio-group
				      v-model="estatusProspecto"
				      row
				      hide-details
				    >
				      <v-radio
				        label="Todos"
				        :value="1"
				      ></v-radio>
				      <v-radio
				        label="Cerrados"
				        :value="2"
				      ></v-radio>
				      <v-radio
				        label="Abiertos"
				        :value="3"
				      ></v-radio>
				      <v-radio
				        label="Inscritos"
				        :value="4"
				      ></v-radio>
				    </v-radio-group>
    			</v-col>

    			<v-col cols="12" md="6" class="d-flex align-center">
    				<v-tooltip bottom color="blue" max-width="280">
    					<template v-slot:activator="{ on, attrs }">
    						<v-btn
    							small
    							tile
    							:color="filtroFuegoCerrado ? 'deep-orange' : 'grey lighten-3'"
    							:dark="filtroFuegoCerrado"
    							v-bind="attrs"
    							v-on="on"
    							@click="filtroFuegoCerrado = !filtroFuegoCerrado"
    						>
							<span class="mr-1">🔥</span>
							Cartera
						</v-btn>
    					</template>
    					<span>Si está activo, al reasignar se marca etiqueta de cartera</span>
    				</v-tooltip>
    			</v-col>
    		</v-row>

    		<v-row>
    			<v-col cols="12">
    				<v-text-field
    				  name="name"
    				  label="Buscar"
    				  id="id"
    				  rounded
    				  v-model="search"
    				  filled
    				  dense
    				  hide-details
    				></v-text-field>
    			</v-col>
    		</v-row>


        <v-data-table
			    :headers="headers"
			    :search="search"
			    :items="filterProspectos"
			    dense
			    class="elevation-0 mt-4"
			    item-key="idprospectos"
			    show-select
			    v-model="prospectosAReasignar"
			  >
	    		<template v-slot:item.idetapa="{ item }">
						<v-chip x-small v-if="item.idetapa == 1" dark color="red">Atrasado</v-chip>
            <v-chip x-small v-if="item.idetapa == 2" dark color="green">Nuevo</v-chip>
            <v-chip x-small v-if="item.idetapa == 3" dark color="pink">Inducción</v-chip>
            <v-chip x-small v-if="item.idetapa == 4" dark color="orange">Con info</v-chip>
            <v-chip x-small v-if="item.idetapa == 5" dark color="brown">Sin info</v-chip>
            <v-chip x-small v-if="item.idetapa == 7" dark color="purple darken-4">2do Contacto</v-chip>
	        </template>

	        <template v-slot:item.finalizo="{ item }">
						<v-chip 
							x-small 
							dark 
							:color="item.finalizo == 1 ? 'dark' : 'green'"
						>
							{{ item.finalizo == 1 ? 'cerrado' : 'Abierto' }}
						</v-chip>
	        </template>

	        <template v-slot:item.idalumno="{ item }">
						<v-chip 
							x-small 
							dark 
							:color="!item.idalumno ? 'dark' : 'green'"
						>
							{{ !item.idalumno ? 'No' : 'Inscrito' }}
						</v-chip>
	        </template>

			  </v-data-table>

    	</v-card-text>

    	<v-card-actions>
		    <v-btn dark block @click="dialogAlerta = true" color="primary">REASIGNARRR</v-btn>
    	</v-card-actions>
    </v-card>


    <v-dialog
    	v-model="dialogAlerta"
    	max-width="400"
    >	
    	<v-card>
    		<v-card-title></v-card-title>
    		<v-card-text class="black--text text-center" >
    			Selecciona una opción para la reasignación
    			<br/>

    			<v-radio-group
			      v-model="opReasigancion"
			      row
			    >
			      <v-radio
			        label="Por zona"
			        :value="1"
			      ></v-radio>
			      <v-radio
			        label="Vendedora"
			        :value="2"
			      ></v-radio>
			    </v-radio-group>

			    <v-autocomplete
	          filled
	          dense
	          clearable
	          v-model="vendedoraUnica"
	          :items="vendedorasDestino"
	          label="Vendedora DESTINO (quien recibirá los contactos)"
	          hide-details
	          item-text="nombre_completo"
	          item-value="id_usuario"
	          return-object
	          v-if="opReasigancion == 2"
	        >
	        </v-autocomplete>
    		</v-card-text>
    		<v-card-actions>
    			<v-btn color="black" dark small @click="dialogAlerta = false">No, cancelar</v-btn>
    			<v-spacer></v-spacer>
    			<v-btn color="green" dark small @click="iniciarReasignacion( )" v-if="opReasigancion">Sí, seguro</v-btn>
    		</v-card-actions>
    	</v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>


<script>
import axios from 'axios';

	import { mapGetters } from 'vuex'


	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'


	export default {
		props:[
			'dialogResaginar'
	  ],

  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,

      headers:  [
			  { text: 'Folio',     value: 'folio'                    },
			  { text: 'Nombre',    value: 'nombre_completo'          },
			  { text: 'Teléfono',  value: 'telefono'                 },
			  { text: 'Plantel',   value: 'sucursal_interes_nombre'  },
			  { text: 'Etapa',     value: 'idetapa'                  },
			  { text: 'Fecha',     value: 'fecha_creacion'           },
			  { text: 'Finalizo',  value: 'finalizo'                 },
			  { text: 'Inscrito',  value: 'idalumno'                 },
			],
      vendedoras: [],
      vendedorasActivas: [],
      vendedora : null,
      prospectos:[],
      prospectosAReasignar: [],

      estatusProspecto: 1,
      dialogAlerta: false,
      opReasigancion: null,
      vendedoraUnica: null,
      search: '',
      plantelFiltro: null,
      fechaInicio: null,
      fechaFin: null,
      filtroFuegoCerrado: false,


    }),

    computed: {
    	...mapGetters('login', ['getdatosUsuarioERPERP']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

      // Planteles de los usuarios ERP (misma fuente que la lista de vendedoras)
      plantelesDisponibles() {
        const map = {}
        for (const el of this.vendedoras) {
          const id = el.idplantel
          if (id == null || id === '' || map[id]) continue
          map[id] = {
            idplantel: id,
            plantel: el.plantel || `Plantel ${id}`,
          }
        }
        return Object.values(map).sort((a, b) =>
          String(a.plantel).localeCompare(String(b.plantel), 'es')
        )
      },

      /** Destino: CRM + listado activo Twilio (para que aparezcan vendedoras aunque no tengan cartera). */
      vendedorasDestino() {
        const byId = {}
        for (const el of [...this.vendedoras, ...this.vendedorasActivas]) {
          const id = el.id_usuario != null ? el.id_usuario : el.iderp
          if (id == null || id === '') continue
          if (!byId[id]) {
            byId[id] = {
              ...el,
              id_usuario: id,
              iderp: el.iderp != null ? el.iderp : id,
              nombre_completo:
                el.nombre_completo ||
                el.nombre_plantel ||
                el.nombre ||
                `Usuario ${id}`,
            }
          }
        }
        return Object.values(byId).sort((a, b) =>
          String(a.nombre_completo).localeCompare(String(b.nombre_completo), 'es')
        )
      },

      filterProspectos( ){

      	let prospectos = this.prospectos

      	if (this.estatusProspecto == 2) {
      		prospectos = prospectos.filter(el => el.finalizo == 1)
      	} else if (this.estatusProspecto == 3) {
      		prospectos = prospectos.filter(el => el.finalizo == 0)
      	} else if (this.estatusProspecto == 4) {
      		prospectos = prospectos.filter(el => el.idalumno)
      	}

      	if (this.plantelFiltro != null && this.plantelFiltro !== '') {
      		prospectos = prospectos.filter(
      			el => String(el.sucursal_interes) === String(this.plantelFiltro)
      		)
      	}

      	if (this.fechaInicio) {
      		prospectos = prospectos.filter(el => {
      			const fecha = this.fechaProspecto(el)
      			return fecha && fecha >= this.fechaInicio
      		})
      	}

      	if (this.fechaFin) {
      		prospectos = prospectos.filter(el => {
      			const fecha = this.fechaProspecto(el)
      			return fecha && fecha <= this.fechaFin
      		})
      	}

      	if (this.filtroFuegoCerrado) {
      		prospectos = prospectos.filter(el => this.esProspectoFuegoCerrado(el))
      	}

      	return prospectos
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      vendedora( value ){
      	this.prospectosAReasignar = []

      	if (value) {
      		const { id_usuario } = value
      		this.getProspectosDetalle(id_usuario)
      	} else if (this.plantelFiltro != null && this.plantelFiltro !== '') {
      		this.getProspectosPorPlantel(this.plantelFiltro)
      	} else {
      		this.prospectos = []
      	}
      },

      plantelFiltro(value) {
      	this.prospectosAReasignar = []

      	// Si hay vendedora, solo filtramos en cliente (filterProspectos)
      	if (this.vendedora) return

      	if (value != null && value !== '') {
      		this.getProspectosPorPlantel(value)
      	} else {
      		this.prospectos = []
      	}
      },
    },

    async created () {
      await this.getVendedorasCRM()
    },

    methods: {
    	fechaProspecto(el) {
    		if (!el) return null
    		if (el.fecha) return String(el.fecha).substr(0, 10)
    		if (el.fecha_creacion) return String(el.fecha_creacion).substr(0, 10)
    		return null
    	},

    	esProspectoFuego(el) {
    		const nombre = String(el && el.nombre_completo || '')
    		if (!nombre) return false
    		return !nombre.toUpperCase().includes('INCOMPLETO')
    	},

    	horasDesdeContacto(el) {
    		const raw = el && (el.fecha_creacion || el.fecha)
    		if (!raw) return null
    		const fecha = new Date(raw)
    		if (Number.isNaN(fecha.getTime())) return null
    		return (Date.now() - fecha.getTime()) / (1000 * 60 * 60)
    	},

    	esProspectoFuegoCerrado(el) {
    		if (!this.esProspectoFuego(el)) return false
    		const cerrado = Number(el.finalizo) === 1
    		const horas = this.horasDesdeContacto(el)
    		const masDe24h = horas != null && horas >= 24
    		return cerrado || masDe24h
    	},

    	getVendedorasCRM () {
      	this.cargar = true
        this.vendedoras = []
        this.vendedorasActivas = []
        return Promise.all([
          this.$http.get('vendedoras.list.crm'),
          this.$http.get('vendedoras.list'),
        ]).then(([crm, list]) => {
        	this.vendedoras = Array.isArray(crm.data) ? crm.data : []
          this.vendedorasActivas = Array.isArray(list.data) ? list.data : []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getProspectosDetalle ( id_usuario ) {
      	this.cargar     = true
        this.prospectos = []

        return this.$http.get('prospectos.detalle/' + id_usuario ).then(response=>{
        	this.prospectos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getProspectosPorPlantel ( idplantel ) {
      	this.cargar = true
      	this.prospectos = []

      	return this.$http.get('prospectos.detalle.plantel/' + idplantel ).then(response => {
      		this.prospectos = response.data
      	}).catch(error => {
      		this.validarError(error.response.data.message)
      	}).finally(() => { this.cargar = false })
      },

      iniciarReasignacion(){
      	if (!this.prospectosAReasignar || !this.prospectosAReasignar.length) {
      		return this.validarError('Selecciona al menos un prospecto')
      	}
      	if (Number(this.opReasigancion) === 2 && !this.vendedoraUnica) {
      		return this.validarError('Selecciona la vendedora DESTINO que recibirá los contactos')
      	}

      	const conCartera = !!this.filtroFuegoCerrado
      	const payload = {
      		vendedora            : this.vendedora,
					prospectosAReasignar : this.prospectosAReasignar,
					opReasigancion       : this.opReasigancion,
					vendedoraUnica       : this.vendedoraUnica,
					carteraFuego         : conCartera,
      	}

      	this.cargar = true
        
        return this.$http.post('reasignar.prospectos.masivo', payload ).then(response=>{

        	if( this.vendedora ){
	      		const { id_usuario } = this.vendedora
	      		this.getProspectosDetalle( id_usuario )
	      	} else if (this.plantelFiltro != null && this.plantelFiltro !== '') {
	      		this.getProspectosPorPlantel(this.plantelFiltro)
	      	}

	      	this.prospectosAReasignar = []
	      	this.vendedoraUnica       = null
	      	this.opReasigancion       = null
	      	this.dialogAlerta         = false

        	const n = response.data && response.data.actualizados
        	this.validarSuccess(
        		conCartera && n
        			? `Reasignados ${n} con etiqueta de cartera. Ver en Unificado → filtro cartera.`
        			: 'Datos reasignados correctamente'
        	)
        	this.cargar = false
        	this.getVendedorasCRM( )
	      	
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      }
    },
  }
</script>